var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { workflowAttachmentApi } from "../workflow-attachment-api";
import ConfirmPopup from "../../common/confirm";
var useStyle = makeStyles({
    rootLabel: {
        cursor: 'pointer',
        textAlign: 'center',
        display: 'flex',
        '&:hover p,&:hover svg,& img': {
            opacity: 1,
        },
        '& p, svg': {
            opacity: 0.4,
        },
        '&:hover img': {
            opacity: 0.3,
        },
    },
    noMouseEvent: {
        pointerEvents: 'none',
        position: 'relative'
    },
    imageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    iconText: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
    },
    hidden: {
        width: '0',
        height: '0'
    },
    onDragOver: {
        '& img': {
            opacity: 0.3,
        },
        '& p, svg': {
            opacity: 1,
        },
    },
});
export default function ImagePicker(props) {
    var _this = this;
    var _a, _b, _c;
    var hoverLabel = "Click or drop to upload";
    var dropLabel = "Drop to upload";
    var classes = useStyle();
    var _d = React.useState(hoverLabel), labelText = _d[0], setLabelText = _d[1];
    var _e = React.useState(false), isDragOver = _e[0], setIsDragOver = _e[1];
    var _f = React.useState(false), isMouseOver = _f[0], setIsMouseOver = _f[1];
    var _g = React.useState(props.url || ""), url = _g[0], setUrl = _g[1];
    var _h = React.useState((_a = props.fileId) !== null && _a !== void 0 ? _a : ''), fileId = _h[0], setFileId = _h[1];
    var _j = React.useState(props.url ? true : false), isLoading = _j[0], setIsLoading = _j[1];
    var _k = React.useState(false), isConfirmDeleteOpen = _k[0], setIsConfirmDeleteOpen = _k[1];
    useEffect(function () {
        setFileId('');
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var attachment, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!fileId && !props.attachmentType)
                            return [2 /*return*/]; // empty
                        setIsLoading(true);
                        if (!props.attachmentType) return [3 /*break*/, 2];
                        return [4 /*yield*/, workflowAttachmentApi.getAttachmentByType(props.step.caseTypeId, props.step.id, props.attachmentType)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, workflowAttachmentApi.getAttachmentById(props.step.caseTypeId, props.step.id, fileId)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        attachment = _a;
                        setIsLoading(false);
                        setUrl(attachment.url);
                        if (attachment.id && !fileId) {
                            setFileId(attachment.id);
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [props.step.id]);
    var stopDefaults = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    var dragEvents = {
        onMouseEnter: function () {
            setIsMouseOver(true);
        },
        onMouseLeave: function () {
            setIsMouseOver(false);
        },
        onDragEnter: function (e) {
            stopDefaults(e);
            setIsDragOver(true);
            setLabelText(dropLabel !== null && dropLabel !== void 0 ? dropLabel : "");
        },
        onDragLeave: function (e) {
            stopDefaults(e);
            setIsDragOver(false);
            setLabelText(hoverLabel);
        },
        onDragOver: stopDefaults,
        onDrop: function (e) {
            stopDefaults(e);
            setLabelText(hoverLabel);
            setIsDragOver(false);
            readFile(e.dataTransfer.files[0]);
        },
    };
    var handleChange = function (event) {
        if (!event.target.files)
            return;
        readFile(event.target.files[0]);
    };
    var readFile = function (file) {
        if (!file)
            return;
        var fileReader = new FileReader();
        fileReader.onload = function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var url, base64Data, isNewUpload, response, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = fileReader.result;
                        base64Data = url.replace('data:', '').replace(/^.+,/, '');
                        isNewUpload = !fileId && !props.attachmentType;
                        setIsLoading(true);
                        if (!props.attachmentType) return [3 /*break*/, 2];
                        return [4 /*yield*/, workflowAttachmentApi.postAttachmentByType(base64Data, props.step.caseTypeId, props.step.id, file.name, props.attachmentType)];
                    case 1:
                        _a = _c.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, workflowAttachmentApi.postAttachmentById(base64Data, props.step.caseTypeId, props.step.id, file.name, fileId)];
                    case 3:
                        _a = _c.sent();
                        _c.label = 4;
                    case 4:
                        response = _a;
                        setIsLoading(false);
                        setUrl(isNewUpload ? "" : response.url);
                        if (response.id)
                            (_b = props.onImageAddOrRemove) === null || _b === void 0 ? void 0 : _b.call(props);
                        return [2 /*return*/];
                }
            });
        }); };
        fileReader.readAsDataURL(file);
    };
    var renderPreview = function () {
        var style = {
            maxWidth: "100%",
            maxHeight: "100%"
        };
        if (props.fileType === "video")
            return _jsx("video", { preload: "metadata", src: url, style: style }, void 0);
        else if (url.toLowerCase().indexOf(".svg?") !== -1)
            return renderSvgImage();
        else
            return _jsx("img", { alt: props.title, src: url, style: style }, void 0);
    };
    var renderSvgImage = function () {
        return _jsx("svg", { children: _jsx("image", { xlinkHref: url }, void 0) }, void 0);
    };
    var onConfirmDeletePopupClose = function (isOK) { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsConfirmDeleteOpen(false);
                    if (!isOK) return [3 /*break*/, 6];
                    setIsLoading(true);
                    if (!props.attachmentType) return [3 /*break*/, 2];
                    return [4 /*yield*/, workflowAttachmentApi.deleteAttachmentByType(props.step.caseTypeId, props.step.id, props.attachmentType)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 2:
                    if (!props.fileId) return [3 /*break*/, 4];
                    return [4 /*yield*/, workflowAttachmentApi.deleteAttachmentById(props.step.caseTypeId, props.step.id, props.fileId)];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4: return [2 /*return*/];
                case 5:
                    (_a = props.onImageAddOrRemove) === null || _a === void 0 ? void 0 : _a.call(props);
                    setFileId('');
                    setUrl("");
                    setIsLoading(false);
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var renderConfirmPopup = function () {
        return (_jsx(ConfirmPopup, { content: "Do you wish to delete this image?", isOpen: isConfirmDeleteOpen, onClose: onConfirmDeletePopupClose }, void 0));
    };
    var onDeleteClick = function () {
        setIsConfirmDeleteOpen(true);
    };
    var accept = props.fileType === "video" ? "video/*" : "image/*";
    var width = 150;
    var height = 150;
    var backgroundColor = "#efefef";
    var inputId = "" + ((_b = props.attachmentType) !== null && _b !== void 0 ? _b : "") + ((_c = props.fileId) !== null && _c !== void 0 ? _c : "");
    if (!inputId)
        inputId = "id-new-file";
    return (_jsxs("div", __assign({ className: "flex-col" }, { children: [renderConfirmPopup(), _jsx("div", __assign({ style: { height: "30px" } }, { children: props.title }), void 0), _jsxs("div", __assign({ style: { width: width + "px", height: height + "px", position: "relative" } }, { children: [_jsx("input", { onChange: handleChange, accept: accept, className: classes.hidden, id: inputId, type: "file", disabled: props.disabled }, void 0), url && !isLoading && !props.disabled && !isDragOver && (_jsx(Box, __assign({ position: "absolute", top: "0", right: "0", zIndex: 100 }, { children: _jsx(IconButton, __assign({ onClick: onDeleteClick, color: "warning" }, { children: _jsx(DeleteIcon, {}, void 0) }), void 0) }), void 0)), _jsx("label", __assign({ htmlFor: inputId }, dragEvents, { className: isDragOver ? classes.onDragOver : classes.rootLabel }, { children: _jsxs(Box, __assign({ width: width, height: height, border: "1px dashed #aaa", bgcolor: backgroundColor, className: classes.noMouseEvent }, { children: [_jsxs(Box, __assign({ position: "absolute", width: width, height: height, className: classes.imageContainer }, { children: [url && !isLoading && renderPreview(), !url && !isLoading && !props.disabled && !isMouseOver && _jsx(IconButton, { children: _jsx(AddCircleIcon, {}, void 0) }, void 0), isLoading && _jsx(CircularProgress, {}, void 0)] }), void 0), !props.disabled && (isDragOver || isMouseOver) && (_jsx(_Fragment, { children: _jsxs(Box, __assign({ width: width, height: height, className: classes.iconText }, { children: [_jsx(CloudUploadOutlinedIcon, { fontSize: "large" }, void 0), _jsx(Typography, { children: labelText }, void 0)] }), void 0) }, void 0))] }), void 0) }), void 0)] }), void 0)] }), void 0));
}
